module.exports = __webpack_public_path__ + "ipetbooking/admin/img/scissors.206e5612.svg";